module.exports = __webpack_public_path__ + "img/logo.c806741b.png";